module.exports = __webpack_public_path__ + "static/media/wave.0eb3484d.webm";